import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import {
  Colors,
  device,
  Modal,
  AddModal,
  AddInnerModalWrapper,
  SvgWrapper,
  AddButtonWrapper,
  PrimaryButtonV2,
} from 'utils';
import { ProjectsActions, PaymentActions } from 'redux/actions';
import { Spin } from 'antd';
import {
  SadFace,
  Declined,
  AcceptIcon,
  IconExclamation,
  InfoIconRed,
} from 'images';
import InputUrlModal from 'scenes/InputUrlModal/InputUrlModal';
const ProjectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 35px;
  .project {
    width: 32%;
    display: inline-block;
    text-align: center;
    margin-bottom: 20px;
    @media ${device.minLaptop} {
      width: 48%;
      margin: auto;
      margin-bottom: 20px;
      margin-top: 0;
    }
    @media ${device.allMobile} {
      width: 90%;
      margin: auto;
      margin-bottom: 20px;
    }
    &:nth-of-type(3n + 2) {
      margin: 0 15px 20px;
      @media ${device.allMobile} {
        width: 90%;
        margin: auto;
        margin-bottom: 20px;
      }
      @media ${device.tablet} {
        margin: 0 14px 20px;
      }
      @media ${device.minLaptop} {
        margin: auto;
        margin-top: 0;
        margin-bottom: 20px;
      }
    }
  }
`;

const YourProjectsWrapper = styled.div`
  margin-bottom: 35px;
  .link {
    text-align: center;
    a {
      background: ${Colors.secondaryColor};
      border: 1px solid ${Colors.secondaryColor};
      color: ${Colors.white};
      text-align: center;
      border-radius: 12px;
      cursor: pointer;
      margin-bottom: 20px;
      padding: 15px 20px;
      min-width: 200px;
      font-size: 18px;
      &:hover {
        background: ${Colors.transparent};
        color: ${Colors.secondaryColor};
      }
      @media ${device.allMobile} {
        font-size: 16px;
      }
    }
  }
`;

const Project = styled.div`
  border: 1px solid ${Colors.grey};
  border-radius: 10px;
  .image {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
    span {
      border-radius: 10px 10px 0 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      background: ${Colors.steel};
    }
  }
  .details {
    padding: 10px 15px;
    h3 {
      font-weight: bold;
      font-size: 22px;
      margin: 15px auto;
    }
    p {
      font-size: 16px;
      max-width: 80%;
      margin: auto;
      margin-bottom: 20px;
    }
  }
  a:hover,
  a:visited {
    color: inherit;
  }
  .card {
    display: flex;
    flex-direction: column;
    height: 100%;
    &__img-wrapper {
      position: relative;
      max-height: 200px;
      border-radius: 10px 10px 0 0;

      & > span,
      img {
        width: 100%;
        height: 180px;
        position: relative;
        display: inline-block;
        background: ${Colors.grey};
        border-radius: 10px 10px 0 0;
        object-fit: cover;
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }
      .declined-icon {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        opacity: 0.7;
        background: ${Colors.grey};
        svg {
          position: absolute;
          top: 41%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        p {
          position: absolute;
          bottom: 10px;
          color: ${Colors.red};
          left: 50%;
          transform: translate(-50%, 0);
          margin: 0;
          font-weight: bold;
        }
        &.successful {
          p {
            color: ${Colors.secondaryColor};
          }
        }
      }
    }
    &__category {
      color: ${Colors.white};
      text-transform: uppercase;
      font-size: 12px;
      background-color: rgba(42, 42, 42, 0.8);
      padding: 5px;
      display: inline-block;
      position: absolute;
      bottom: 0;
      left: 0;
      margin: 0;
      opacity: 0.5;
    }
    &__form {
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      display: flex;
      align-items: center;
      color: ${Colors.black};
      text-transform: uppercase;
      font-size: 12px;
      background: ${Colors.white};
      padding: 5px;
      position: absolute;
      bottom: 0;
      right: 0;
      margin: 0;
      opacity: 0.5;
    }
    &__content {
      padding: 10px 20px;
      flex: 1;
      footer {
        display: flex;
        justify-content: space-between;
        p {
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 1;
          margin-top: 5px;
          span {
            margin-right: 5px;
          }
        }
      }
    }
    &__name {
      margin: 0;
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
    }
    &__description {
      font-size: 16px;
      margin: 0;
      width: 100%;
      overflow-x: hidden;
    }
    &__info {
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin: 10px 0 0;
      p {
        margin: 0;
      }
    }
    &__actions {
      display: flex;
      justify-content: space-between;
      gap: 10px;
      padding: 0 20px 10px;
      margin-top: auto; // pushes actions to the bottom
    }
    &__button {
      flex: 1;
      font-size: 12px;
      font-weight: 600;
      padding: 8px;
      border: none;
      border-radius: 4px;
      background: ${Colors.transparent};
      color: ${Colors.steel};
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
const SadFaceWrapper = styled.div`
  text-align: center;
  margin: 25px auto;
`;
class YourProjects extends Component {
  componentDidMount() {
    const { getMyProjects } = this.props;
    getMyProjects();
    this.scrollToStartedProjects();
  }
  static propTypes = {
    getMyProjects: PropTypes.func.isRequired,
    myProjects: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    duplicateDraft: PropTypes.func.isRequired,
    deleteDraft: PropTypes.func.isRequired,
    deleteDraftReload: PropTypes.func.isRequired,
    businessTypeMismatch: PropTypes.bool,
    stripeStatus: PropTypes.bool,
    getStripeStatus: PropTypes.func.isRequired,
    getBusinessType: PropTypes.func.isRequired,
    submitDraft: PropTypes.func.isRequired,
    draftDeleted: PropTypes.bool.isRequired,
  };
  state = {
    inputUrl: false,
    currentProjectId: null,
    showErrorModal: false,
    showConfirmationModal: false,
    waitingForLoad: false,
    timeoutReached: false,
  };

  timeoutId = null;

  goToProjectDetailsPage(projectId) {
    this.props.history.push(`/my-project/${projectId}`);
  }

  handleInputModal = (id) => {
    this.setState({ inputUrl: true, currentProjectId: id });
  };

  handleDuplicateProject = (url) => {
    const { duplicateDraft } = this.props;
    const { currentProjectId } = this.state;
    currentProjectId && duplicateDraft(currentProjectId, url);
  };

  handleDeleteProject = () => {
    const { deleteDraft } = this.props;
    const { currentProjectId } = this.state;
    this.closeConfirmationModal();
    currentProjectId && deleteDraft(currentProjectId);
  };

  handleErrorModal = () => {
    this.setState({ showErrorModal: false });
  };

  openConfirmationModal = (id) => {
    this.setState({ currentProjectId: id, showConfirmationModal: true });
  }

  closeConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  }

  onSubmit = async (id) => {
    const { getStripeStatus, getBusinessType } = this.props;

    getStripeStatus(id);
    getBusinessType(id);

    this.setState({
      currentProjectId: id,
      waitingForLoad: true,
      timeoutReached: false,
    });

    this.timeoutId = setTimeout(() => {
      this.setState({
        currentProjectId: null,
        waitingForLoad: false,
        timeoutReached: true,
        showTimeoutModal: true,
      });
    }, 5000);
  };

  // Links like /profile#started-projects (e.g. "Eigene Projekte" in the project
  // management) jump here. The lists above load asynchronously and push the heading
  // down, so we wait until its position is stable before scrolling.
  scrollToStartedProjects = () => {
    if (this.scrolledToHash) return;
    if (window.location.hash !== '#started-projects') return;
    this.scrolledToHash = true;
    let lastTop = null;
    let ticks = 0;
    this.hashTimer = setInterval(() => {
      const heading = document.getElementById('started-projects');
      ticks += 1;
      if (!heading) return;
      const top = heading.getBoundingClientRect().top + window.pageYOffset;
      const stable = lastTop !== null && Math.abs(top - lastTop) < 2;
      lastTop = top;
      if ((stable && !this.props.loading) || ticks >= 16) {
        clearInterval(this.hashTimer);
        window.scrollTo({ top: top - 100, behavior: 'smooth' });
      }
    }, 250);
  };

  componentDidUpdate(prevProps) {
    const { getMyProjects, deleteDraftReload, draftDeleted } = this.props;
    if (draftDeleted) {
      getMyProjects();
      deleteDraftReload();
    }
    const { currentProjectId, waitingForLoad } = this.state;
    if (waitingForLoad && prevProps.loading && !this.props.loading) {
      clearTimeout(this.timeoutId);

      const { businessTypeMismatch, stripeStatus, submitDraft } = this.props;

      this.setState({ waitingForLoad: false });

      if (businessTypeMismatch.mismatch && stripeStatus !== 'no_account') {
        this.setState({ showErrorModal: true, currentProjectId: null });
        return;
      }
      console.log(currentProjectId);
      currentProjectId && submitDraft(currentProjectId);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    clearInterval(this.hashTimer);
  }

  render() {
    const { myProjects, loading } = this.props;
    const { inputUrl, currentProjectId } = this.state;
    // console.log('myProjects');
    // console.log(myProjects);
    return (
      <YourProjectsWrapper>
        <h2 id="started-projects">Deine gestarteten Projekte:</h2>
        <Spin spinning={loading}>
          <>
            {myProjects.length > 0 ? (
              <ProjectsWrapper>
                {myProjects.map(
                  (project, indx) =>
                    project.name !== 'ramadan2025' &&
                    project.name !== 'dhullhijjah2026' && (
                      <Project
                        className="project"
                        key={`${JSON.stringify(project)}-${indx}`}
                      >
                        <Link
                          className="card"
                          to={
                            project.status === 'draft'
                              ? `/start-project/${project.id}`
                              : project.status === 'totally_declined'
                                ? `#!`
                                : `/my-project/${project.id}`
                          }
                        >
                          <div className="card__img-wrapper">
                            {project.status === 'totally_declined' && (
                              <>
                                <span className="declined-icon">
                                  <SvgWrapper width={'100%'} height={'100%'}>
                                    <Declined width={'70%'} height={'70%'} />
                                  </SvgWrapper>
                                  <p>Abgelehnt</p>
                                </span>
                              </>
                            )}
                            {project.status === 'successful' && (
                              <>
                                <span className="declined-icon successful">
                                  <SvgWrapper width={'100%'} height={'100%'}>
                                    <AcceptIcon width={'70%'} height={'70%'} />
                                  </SvgWrapper>
                                  <p>Erfolgreich</p>
                                </span>
                              </>
                            )}
                            {
                              <picture>
                                <img src={project.photo} alt={project.name} />
                              </picture>
                              // isMobile() ? (
                              //   <>
                              //     {project.mobile_photo ? (
                              //       <picture>
                              //         <img src={project.mobile_photo} alt={project.name} />
                              //       </picture>
                              //     ) : project.photo ? (
                              //       <picture>
                              //         <img src={project.photo} alt={project.name} />
                              //       </picture>
                              //     ) : (
                              //       <span>Projektbild</span>
                              //     )}
                              //   </>
                              // ) : (
                              //   <>
                              //     {project.photo ? (
                              //       <picture>
                              //         <img src={project.photo} alt={project.name} />
                              //       </picture>
                              //     ) : project.mobile_photo ? (
                              //       <picture>
                              //         <img src={project.mobile_photo} alt={project.name} />
                              //       </picture>
                              //     ) : (
                              //       <span>Projektbild</span>
                              //     )}
                              //   </>
                              // )
                            }

                            {project.category && (
                              <p className="card__category">
                                {project.category}
                              </p>
                            )}
                          </div>
                          <div className="card__content">
                            <h2 className="card__name">{project.name}</h2>
                            <p className="card__description">
                              {project.description}
                            </p>
                          </div>
                          {(project.status === 'draft' ||
                            project.status === 'accepted_and_draft') && (
                              <div className="card__info">
                                <img
                                  src={IconExclamation}
                                  alt="Exclamation icon"
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                    marginRight: '5px',
                                  }}
                                />
                                <p>Enthält nicht-eingereichte Änderungen</p>
                              </div>
                            )}
                          {(project.status === 'pending' ||
                            project.status === 'edit_pending') && (
                              <div className="card__info">
                                <img
                                  src={IconExclamation}
                                  alt="Exclamation icon"
                                  style={{
                                    width: '16px',
                                    height: '16px',
                                    marginRight: '5px',
                                  }}
                                />
                                <p> Projekt wird evaluiert</p>
                              </div>
                            )}
                          <div className="card__actions">
                            {project.status === 'draft' ||
                              project.status === 'pending' ||
                              project.status === 'declined' ||
                              project.status === 'draft_and_pending' ? (
                              <button
                                className="card__button"
                                disabled={project.status === 'pending'}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.openConfirmationModal(project.id);
                                }}
                              >
                                Löschen
                              </button>
                            ) : (
                              <button
                                className="card__button"
                                disabled={
                                  project.status === 'pending' ||
                                  project.status === 'edit_pending'
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.handleInputModal(project.id);
                                }}
                              >
                                Duplizieren
                              </button>
                            )}
                            {project.status === 'accepted_and_draft' ||
                              (project.status === 'draft' &&
                                (project.stripe_status === 'enabled' ||
                                  project.stripe_status ===
                                  'enabled_and_eventually_due')) ? (
                              <button
                                className="card__button"
                                style={{ color: Colors.newSecondaryColor }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.onSubmit(project.id);
                                  //this.history.push(`/start-project/${project.id}`)
                                }}
                              >
                                Einreichen
                              </button>
                            ) : (
                              <>
                                {project.status === 'draft' ? (
                                  <button
                                    className="card__button"
                                    style={{
                                      color: Colors.newSecondaryColor,
                                    }}
                                    disabled={
                                      project.status === 'successful' ||
                                      project.status === 'finished'
                                    }
                                  >
                                    Bearbeiten
                                  </button>
                                ) : (
                                  <button
                                    className="card__button"
                                    style={{
                                      color: Colors.newSecondaryColor,
                                    }}
                                  >
                                    Anzeigen
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </Link>
                      </Project>
                    )
                )}
              </ProjectsWrapper>
            ) : (
              <SadFaceWrapper>
                <SvgWrapper width={'150px'} height={'auto'}>
                  <SadFace />
                </SvgWrapper>
              </SadFaceWrapper>
            )}
            {inputUrl && (
              <Modal
                width="830px"
                title={
                  <div style={{ padding: 20 }}>
                    Bitte gib eine neue URL ein.
                  </div>
                }
                showModal={inputUrl}
                handelCloseModal={() =>
                  this.setState({ inputUrl: false, currentProjectId: null })
                }
              >
                <InputUrlModal
                  projectId={currentProjectId}
                  handleDuplicateProject={this.handleDuplicateProject}
                />
              </Modal>
            )}
            <AddModal
              showModal={this.state.showErrorModal}
              handelCloseModal={this.handleErrorModal}
              width="40%"
            >
              <AddInnerModalWrapper>
                <img
                  style={{ height: '48px', width: '48px' }}
                  src={InfoIconRed}
                  alt="Error icon"
                />
                <h2 style={{ fontSize: '18px' }}>
                  Fehlerhafte Angabe bei Stripe
                </h2>
                <p>
                  <b>
                    Du hast bei Stripe einen anderen Geschäftstyp ausgewählt,
                    als bei uns angegeben.
                  </b>
                </p>
                <p>
                  Dadurch kann es zu Problemen bei deiner Auszahlung kommen.
                  Bitte bearbeite dein Projekt und versuche es erneut.
                </p>
              </AddInnerModalWrapper>
            </AddModal>
            <AddModal
              showModal={this.state.showConfirmationModal}
              handelCloseModal={this.closeConfirmationModal}
              width="20%"
            >
              <AddInnerModalWrapper>
                <h2 style={{ fontSize: '18px' }}>Bestätigung</h2>
                <p>
                  Bist du sicher, dass du dieses Projekt löschen willst?
                </p>
              </AddInnerModalWrapper>
              <AddButtonWrapper>
                <div className="space-between">
                  <PrimaryButtonV2
                    type="button"
                    primary="true"
                    onClick={this.closeConfirmationModal}
                  >
                    <p>Abbrechen</p>
                  </PrimaryButtonV2>

                  <PrimaryButtonV2
                    type="primary"
                    onClick={this.handleDeleteProject}
                  >
                    <p>Löschen</p>
                  </PrimaryButtonV2>
                </div>
              </AddButtonWrapper>
            </AddModal>
          </>
        </Spin>
        <div className="link">
          {/* <Link to="/start-project">Jetzt neues Projekt starten</Link> */}
        </div>
      </YourProjectsWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { myProjects, loading, errors, businessTypeMismatch, draftDeleted } =
    state.projects;
  const { stripeStatus } = state.payment;
  return {
    myProjects,
    loading,
    errors,
    stripeStatus,
    businessTypeMismatch,
    draftDeleted,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMyProjects: () => dispatch(ProjectsActions.getMyProjects()),
  duplicateDraft: (projectId, url) =>
    dispatch(ProjectsActions.duplicateDraft(projectId, url)),
  deleteDraft: (projectId) => dispatch(ProjectsActions.deleteDraft(projectId)),
  deleteDraftReload: () => dispatch(ProjectsActions.deleteDraftReload()),
  getStripeStatus: (projectId) =>
    dispatch(PaymentActions.getStripeStatus(projectId)),
  getBusinessType: (projectId) =>
    dispatch(ProjectsActions.getBusinessType(projectId)),
  submitDraft: (projectId) => dispatch(ProjectsActions.submitDraft(projectId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(YourProjects);
